import {ACTION_TYPE} from '../../core/redux/actionType';
import {ApiReducer, makeApiAction, makeApiReducer, RsaaTypes} from '../../core/redux/api/reduxStandardApiAction';
import {apiChangeUserPassword} from '../../core/redux/api/endpoints';
import {hasTrippedBreaker, updateBreaker} from '../../core/redux/api/circuitBreaker/module';
import {IAppState} from '../../core/redux/IAppState';
import {addError, addLoading, removeLoadingAndError} from '../../core/redux/api/module';

export const KEY_ACTION = ACTION_TYPE.UPDATE_PASSWORD_REQUEST;
export const ACTIONS    = [
  ACTION_TYPE.UPDATE_PASSWORD_REQUEST,
  ACTION_TYPE.UPDATE_PASSWORD_RESPONSE,
  ACTION_TYPE.UPDATE_PASSWORD_ERROR,
]

export const updatePasswordAction = (userId:string, newPassword: string) => makeApiAction(
  {
    method:   'PUT',
    headers:  (state: IAppState) => ({
      'content-type':  'application/json',
      'Authorization': `Bearer ${state.auth.bearerToken}`,
    }),
    endpoint: (state: IAppState) => apiChangeUserPassword(state.userState.userId, state.selectedResort.resortId, userId, newPassword),
    body:     JSON.stringify({
      newPassword: newPassword
    }),
    types:    ACTIONS.map(action => ({ type: action, meta: { newPassword } })) as RsaaTypes,
    bailout:  (state: IAppState) => hasTrippedBreaker(state, KEY_ACTION)
  },
);

const reducer: ApiReducer<any> = (state, action, error, isLoading, payload) =>{
  const newPassword = action.meta.newPassword;

  if (isLoading) {
    return addLoading(state, newPassword, KEY_ACTION);
  }

  const withBreaker = updateBreaker(state, KEY_ACTION, !!error);

  if (error) {
    return addError(withBreaker, newPassword, KEY_ACTION, error);
  }

  return removeLoadingAndError(withBreaker, newPassword, KEY_ACTION);
}

export const updatePasswordReducer = makeApiReducer(ACTIONS, KEY_ACTION, reducer);